var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "panel panel-grey m-b-xl" }, [
    _c("div", { staticClass: "panel-body" }, [
      _c("h3", { staticClass: "m-t-none" }, [_vm._v("Tagline")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Describe yourself in a few words. This will be visible below your name when your profile is viewed."
        ),
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.$v.stateTagline.$invalid ? "has-error" : "" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.$v.stateTagline.$model,
              expression: "$v.stateTagline.$model",
            },
          ],
          staticClass: "form-control",
          attrs: { name: "tagline", type: "text" },
          domProps: { value: _vm.$v.stateTagline.$model },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.$v.stateTagline, "$model", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c("p", { staticClass: "help-block" }, [
          _vm._v(_vm._s(_vm.charactersRemaining) + " Characters Left"),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "panel-footer" },
      [
        _c(
          "ladda-button",
          {
            staticClass: "btn btn-sm btn-primary",
            attrs: { click: _vm.handleUpdateTagline },
          },
          [_vm._v("\n      Save Changes\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }